module.exports = __webpack_public_path__ + "static/media/quotesHeader@2x.59a0c04f.png";